var TextArea = require('./textArea'),
    Line = require('./line'),
    Box = require('./box'),
    ShapeUtils = require('../../../../canvas/models/shapeUtils');

/**
 * Not exactly the line, it's going to inherit fontsize and line-height,
 * which is OK -- they currently aren't used but could be.
 */

module.exports = TextArea.extend({

    defaults: _.extend( {}, Line.prototype.defaults, {

        wd: null,
        originalWd: null ,// this will exist for sanitizing any characters, like different kinds of dashes; sanitized output will be stored in wd; and the original here; facilitate easy debugging
        isTextSanitized: false, // store a flag to mark if the word was sanitized ( wd != originalWd ); same as originalWd === null

        pageLevelLineId: null,
        pageLevelZoneWordId: null, // really index - necessary ?
        pageLevelLineWordId: null, // really index - necessary ?

        isDerived: false,
        derivedParentId: null // for original subword that compose derived words, a link back to the derived parent -- only will be put on words in the original, not derived array

    }),


    parse: function(attrs, options ) {

        var baseAttrs = Line.prototype.parse.apply( this, arguments );

        var wdRaw = attrs.wd;
        var sanitizedWord = this._getSanitizedWord( wdRaw );

        if ( wdRaw === sanitizedWord ) {

            baseAttrs.wd = attrs.wd;

        } else {

            baseAttrs.wd = sanitizedWord;
            baseAttrs.originalWd = wdRaw;
            baseAttrs.isTextSanitized = true;
        }

        baseAttrs.pageLevelLineId = options.pageLevelLineId;
        baseAttrs.pageLevelZoneWordId = options.pageLevelZoneWordId;
        baseAttrs.pageLevelLineWordId = options.pageLevelLineWordId;

        return baseAttrs;

    },


    _generatePageKeyId: function(options) {
        return options.pageNumber + '_' + options.pageLevelZoneId + '_' + options.pageLevelLineId + '_' + options.page_level_id;
    },

    /* Called post-parse -- needs other model data */
    setDerivedBoxes: function( box_px_adjustment, fdd_xdpi, line, prevLineInZone, nextLineInZone, prevWordOnLine, nextWordOnLine ) {


        var boxPxDerived = this._generateBoxPxDerived(
            this.get('boxPx'), box_px_adjustment, line, prevLineInZone, nextLineInZone, prevWordOnLine, nextWordOnLine
        );

        var boxFDDZoneUnitsDerived = TextArea.prototype._generateBoxFDDZoneUnitsDerived.call(
            this, boxPxDerived, fdd_xdpi
        );

        this.set({
            boxPxDerived: boxPxDerived,
            boxFDDZoneUnitsDerived: boxFDDZoneUnitsDerived
        });

    },

    /**
     * Difference from the base:
     * Vertical: at least the size of the word's line plus padding, up to the prior/next line in it's zone.
     * - I have seen any cases where not covering just line fails to cover the word.
     * - Perhaps would want in the middle of the line?
     * Horizontal: at the padding but without overlapping the adjacent words on its line.
     * - Padding helps to cover words if the OCR engine is off.
     * Note: we aren't taking page dimensions into account ( we could )
     */
    _generateBoxPxDerived: function( boxPx, box_px_adjustment, line, prevLineInZone, nextLineInZone, prevWordOnLine, nextWordOnLine ) {

        /* --- Vertical ---- */

        var lineBoxPx = line.get('boxPx');

        var lineTopPlusPadding = lineBoxPx.get('t') - box_px_adjustment;
        var lineBottomPlusPadding = lineBoxPx.get('b') + box_px_adjustment;

        var t = prevLineInZone
            ? Math.max( lineTopPlusPadding, prevLineInZone.get('boxPx').get('b') )
            : lineTopPlusPadding;

        var b = nextLineInZone
            ? Math.min( lineBottomPlusPadding, nextLineInZone.get('boxPx').get('t') )
            : lineBottomPlusPadding;

        /* --- Horizontal --- */

        var wordLeftPlusPadding = boxPx.get('l') - box_px_adjustment;
        var wordRightPlusPadding = boxPx.get('r') + box_px_adjustment;

        var l = prevWordOnLine
            ? Math.max( wordLeftPlusPadding, prevWordOnLine.get('boxPx').get('r') )
            : wordLeftPlusPadding;

        var r = nextWordOnLine
            ? Math.min( wordRightPlusPadding, nextWordOnLine.get('boxPx').get('l') )
            : wordRightPlusPadding;

        return new Box({
            l: l,
            r: r ,
            t: t,
            b: b
        } );

    },


    getWord: function() {
        return this.get('wd');
    },

    /**
     * For time being, normalize all dash or hyphen like characters as a regular '-'.
     * This is necessary for logic implemented that allows us to search for words for dashes.
     * Maybe later will need further sanitize the raw output.
     * Definitely the types Nuance recognizes ( see documentation ) and while we're at it, some others
     * just in case they appear or we hook into different OCR engine, eg Abby );
     * Nuance documentation says recognizes the following:
     *  - Em Dash: 0x2014
     *  - En Dash: 0x2013
     *  - Soft Hyphen: 0x20ad ( note: not sure how this works in practice, these should not be visible )
     *  - Hyphen-Minus: 0x002d ( this is what we are normalizing to)
     *  Others we're filtering -- this is a good source: http://jkorpela.fi/dashes.html --
     *  not including all but ones that could be more common than others:
     *  - u2010: hyphen
     *  - u2011: non-breaking-hyphen
     *  - u2012: figure dash
     *  - u2015: horizontal bar
     *  Note the regexp must be case sensitive ( eg \u00AD )
     */
    _getSanitizedWord: function( wdRaw ) {

        var HYPHEN_AND_DASH_REG_EXP =
                /\u2010|\u2011|\u2012|\u2013|\u2014|\u2015|\u00AD/g;

        return wdRaw.replace( HYPHEN_AND_DASH_REG_EXP, '-' );

    }



});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/positionalTextModels/textAreaModels/word.js
 ** module id = 354
 ** module chunks = 0
 **/